
export const templateEdgesScene = (target: string) => ({ id: `e1-${target}`, source: '1', target, type: 'smoothstep' });

